import { request } from '@/utils/ajax';

export function getSystemInfo(): Promise<SystemInfo> {
    return request('api/system').then((x) => x.json());
}

export interface SystemInfo {
    environmentName: string;
    frontendUrl: string;
}